import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  dateformat: {
    fontWeight: "bold",
    fontSize: 16,
  },
  inputLabel: {
    fontSize: "16px",
    lineHeight: "24px",
    color: theme.custom.color.blackRussian,
    fontWeight: 400,
  },
  value: {
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    color: theme.custom.color.blackRussian,
    display: "inline-flex",
  },
  wrapper: {
    position: "relative",
  },
  saveicon: {
    opacity: 0.5,
    position: "absolute",
    top: 23,
    right: 0,
    fontSize: "large",
  },
  placeholder: {
    "& .MuiInputLabel-root": {
      fontSize: "16px",
      color: "#969796 !important",
      fontWeight: "600 !important",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.custom.color.black,
    },
    "& .MuiInput-underline": {
      "&:after": {
        borderBottom: theme.custom.color.black,
      },
    },
    "& .MuiInputBase-root": {
      paddingRight: theme.spacing(2),
    },
  },
  editicon: {
    fontSize: "large",
    position: "absolute",
    margin: theme.spacing(0, 0, 0, 1),
  },
  iconAlign: {
    padding: theme.spacing(0, 0, 0, 1),
  },
  pointer: {
    cursor: "pointer",
  },
}));
